import React from 'react';
import { Modal, message, Row, Col, Table, Button, Tabs, Alert } from 'antd';
import { CopyOutlined, GiftOutlined, LockOutlined } from '@ant-design/icons';

import { useCurrentOrganization, useScreenSize } from '../../../hooks';
import { useModalContext } from '../crud/modal-context';
import { useReferrals } from '../organizationUsers/hook';
import { NewTable } from '../crud/new-table';
import { DATE_FORMAT } from 'utils/date';
import { getAmountDisplay } from 'utils/amount';
import { SubscriptionStatus } from 'redux/reducers/authReducer';

export function ReferModal() {
  const isSmallScreen = useScreenSize();
  const currentOrganization = useCurrentOrganization();
  const modalContext = useModalContext();

  const { loading, data, total, pagination, setPagination } = useReferrals({ idOrganization: currentOrganization.id });

  function copyToClipboard(prefix: string, content: string) {
    try {
      navigator.clipboard.writeText(content);
      message.success(`${prefix} copied to clipboard`);
    } catch (e) {
      window.alert('Copybord is only supported in https protocol');
    }
  }

  const copyCodeToClipboard = () => {
    copyToClipboard('Code', currentOrganization.referralCode);
  };

  const copyUrlToClipboard = () => {
    copyToClipboard('URL', `${window.location.host}/sign-up?referral=${currentOrganization.referralCode}`);
  };

  return (
    <Modal
      title={
        <>
          <GiftOutlined /> Share the Love, Earn Bugal Credits
        </>
      }
      visible={modalContext.visible}
      onCancel={() => modalContext.setVisible(false)}
      footer={
        <Row justify="space-between">
          <Row>
            <Button onClick={() => modalContext.setVisible(false)}>Close</Button>
          </Row>
        </Row>
      }
      width={720}
      wrapClassName={isSmallScreen ? 'fullscreen' : ''}
    >
      <Tabs>
        <Tabs.TabPane tab="Your code" key="0">
          <Row>
            <h3>Refer now for $30 Bugal credit, offer ends soon.</h3>
            <ul>
              <li>Share your code or link with someone.</li>
              <li>
                You'll receive <strong>$30</strong> in Bugal Credits for each successful paid subscription referral.
              </li>
              <li>
                They'll earn <strong>$30</strong> in Bugal Credits for their subscription.
              </li>
            </ul>
            It's a win-win! Start sharing Bugal and enjoy the benefits together!
          </Row>
          {currentOrganization.subscriptionStatus !== SubscriptionStatus.Active && (
            <Row justify="center" gutter={[16, 16]} style={{ marginTop: '10px' }}>
              <Alert type="warning" showIcon icon={<LockOutlined />} message="Unlock Bugal's referral program by subscribing to a paid plan today!"></Alert>
            </Row>
          )}
          {currentOrganization.subscriptionStatus === SubscriptionStatus.Active && (
            <>
              <Row justify="center" gutter={[16, 16]} style={{ marginTop: '10px' }}>
                <Col>
                  <Button type="primary" shape="round" onClick={copyCodeToClipboard}>
                    {currentOrganization.referralCode} <CopyOutlined />
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" shape="round" onClick={copyUrlToClipboard}>
                    Shareable URL <CopyOutlined />
                  </Button>
                </Col>
              </Row>
            </>
          )}
          <Row justify="center" style={{ fontSize: '10px', marginTop: '10px' }}>
            Refer & Earn&nbsp;
            <a target="_blank" rel="noreferrer" href="https://www.bugal.com.au/refer-earn-program-terms-and-conditions">
              Terms and Conditions
            </a>
          </Row>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Your referrals" key="1">
          <NewTable
            data={data}
            loading={loading}
            total={total}
            pagination={pagination}
            onPaginationChange={setPagination}
            actions={[]}
            renderBigScreen={[
              <Table.Column key="status" dataIndex="status" title="Status" />,
              <Table.Column
                key="referee"
                dataIndex="referee"
                title="Referral"
                render={(value) => {
                  return value.name;
                }}
              />,
              // This is causing React warnings when the same date repeats
              <Table.Column
                key="createdAt"
                dataIndex="createdAt"
                title="Date"
                render={(value: moment.Moment) => {
                  return value.format(DATE_FORMAT);
                }}
              />,
              <Table.Column key="creditGivenToReferrer" dataIndex="creditGivenToReferrer" title="Amount" render={(value) => (value ? getAmountDisplay(value) : '-')} />,
            ]}
            renderSmallScreen={(obj) => {
              return (
                <Row align="middle">
                  <Col flex="auto">
                    <div style={{ /*color: colourByStatus(obj),*/ fontWeight: 'bold', fontSize: '14px' }}>{obj.status}</div>
                    <div>{obj.referee.name}</div>
                    <div>{obj.createdAt.format(DATE_FORMAT)}</div>
                  </Col>
                </Row>
              );
            }}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
}
